<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Offer</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="company"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-select
                  name="offer_id"
                  class="form-group"
                  label="Select Offer"
                  :items="offers"
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    company: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      offers_data: [],
      key: 1,
    };
  },

  mounted() {
    this.fetchData();
  },
  computed: {
    offers() {
      return this.getSelectOptions(this.offers_data);
    },
    url() {
      return `api/v1/company/${this.company.id}/userOffer`;
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    offerAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
    },
    fetchData() {
      this.$http.get("/api/v1/offers").then((response) => {
        this.offers_data = response.data;
      });
    },
  },
};
</script>
